import {ErrorHandler, Provider} from '@angular/core';
import {DashboardErrorHandler} from './dashboard.error.handler';
import {DashboardErrorResolver} from './dashboard.error.resolver';
import {CommonErrorResolver} from '../../../../common/providers/';

export * from './dashboard.error.handler';
export * from './dashboard.error.resolver';

export const ERROR_PROVIDERS: Provider[] = [
    {provide: CommonErrorResolver, useClass: DashboardErrorResolver},
    {provide: ErrorHandler, useClass: DashboardErrorHandler}
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/error/index.ts